import { defineStore } from 'pinia';
import { getStorage, readStorageJSON, removeStorageItem, writeStorageJSON } from '@/utils/secure-storage';

const CARD_ORDER_STORAGE_KEY = 'h5:card-order';

function loadDraft() {
  const localStorage = getStorage('local');
  const sessionStorage = getStorage('session');
  const localDraft = readStorageJSON(CARD_ORDER_STORAGE_KEY, null, {
    storage: localStorage
  });

  if (localDraft && typeof localDraft === 'object') {
    return localDraft;
  }

  const sessionDraft = readStorageJSON(CARD_ORDER_STORAGE_KEY, {}, {
    storage: sessionStorage
  });

  if (sessionDraft && Object.keys(sessionDraft).length) {
    writeStorageJSON(CARD_ORDER_STORAGE_KEY, sessionDraft, {
      storage: localStorage
    });
    removeStorageItem(CARD_ORDER_STORAGE_KEY, {
      storage: sessionStorage
    });
  }

  return sessionDraft || {};
}

function persistDraft(draft) {
  writeStorageJSON(CARD_ORDER_STORAGE_KEY, draft || {}, {
    storage: getStorage('local')
  });
}

export const useCardOrderStore = defineStore('card-order', {
  state: () => ({
    draft: loadDraft()
  }),
  actions: {
    hydrate() {
      this.draft = loadDraft();
    },
    mergeDraft(payload) {
      this.draft = {
        ...this.draft,
        ...(payload || {})
      };
      persistDraft(this.draft);
    },
    clearDraft() {
      this.draft = {};
      removeStorageItem(CARD_ORDER_STORAGE_KEY, {
        storage: getStorage('local')
      });
    }
  }
});
